var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 44,
    viewBox: "0 0 42 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 16C2.0609 14.3909 2.2402 12.7534 2.53864 11.1003C2.76119 9.8675 2.87247 9.25111 3.25248 8.8293C3.63249 8.40749 4.57149 8.10826 6.44947 7.50981C11.0681 6.03798 14.9735 2 20.9965 2C27.0197 2 30.9295 6.03829 35.55 7.50997C37.4278 8.10809 38.3668 8.40716 38.7468 8.82897C39.1269 9.25079 39.2383 9.86728 39.4609 11.1003C39.7594 12.7534 39.9389 14.3909 40 16M35.8901 32C33.2501 36.0453 29.3545 39.275 24.2293 41.2349C22.8956 41.745 22.2287 42 21.0031 42C19.7774 42 19.1105 41.745 17.7767 41.235C12.6512 39.275 8.75451 36.0453 6.11333 32",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22L16 24M16 24L18 26M16 24L18 22M16 24L14 26",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22L6 24M6 24L8 26M6 24L8 22M6 24L4 26",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 22L26 24M26 24L28 26M26 24L28 22M26 24L24 26",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34 22L36 24M36 24L38 26M36 24L38 22M36 24L34 26",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShield);
export default __webpack_public_path__ + "static/media/icon-shield.75c8041a2f5c14277f98c44a5ff9b514.svg";
export { ForwardRef as ReactComponent };